<div class="full-width full-height">
  <app-loader [enable]="loader">
    <iframe width="100%"
            height="100%"
            style="overflow: hidden; border: 0;"
            [src]="link"
            referrerpolicy="unsafe-url"
            (load)="loadEvent($event)"></iframe>
  </app-loader>
</div>
